import React from 'react';

const Credits = () => {
  return (
    <div className="credits container mx-auto py-8 text-center">
      <h2 className="text-3xl font-bold mb-4">Credits</h2>
      <p>
        Thanks to all performers, photographers, and cultural enthusiasts who helped preserve and
        showcase Yakshagana and Bootha Kola traditions.
      </p>
      <ul className="mt-4 list-disc list-inside text-left md:text-center">
        <li>Photography: Raghuram Shetty</li>
        <li>Performers: Local Yakshagana & Bootha Kola Artists</li>
        <li>Website Development: Your Name</li>
      </ul>
    </div>
  );
};

export default Credits;
